module.exports = __webpack_public_path__ + "static/img/17.8a54ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/17.png
// module id = F3iG
// module chunks = 0